<template>
    <div ref="performScript"></div>
</template>

<script>
    import {
        mapActions,
        mapGetters,
    } from 'vuex';

    import { errorGuard } from '@utils/ErrorGuard';
    import { sendMultimediaRequestResultAnalytic } from '@core/services/media/MediaService';

    export default {
        props: {
            uuid: {
                type: String,
                required: true,
            },
            streamId: {
                type: String,
                required: true,
            },
            username: {
                type: String,
                required: true,
            },
            containerWidth: {
                type: Number,
                required: true,
            },
        },
        mounted() {
            this.createPlayer();
        },
        computed: {
            ...mapGetters('ui/sportOffer', [
                'expandedEventData',
            ]),
        },
        methods: {
            ...mapActions('ui/sportOffer', [
                'getPerform',
            ]),
            async createPlayer() {
                await errorGuard(async () => {
                    const perform = await this.getPerform({
                        streamId: this.streamId,
                        uuid: this.uuid,
                        match: this.expandedEventData,
                    });
                    this.token = perform.token;
                    this.hashedUsername = perform.hashedUsername;
                });

                const script = document.createElement('script');
                script.type = 'text/javascript';
                script.src = '//player.performgroup.com/csb.js';
                script.setAttribute('data-uuid', this.uuid);
                script.setAttribute('data-outletkey', '1f4jp8n8pn2rh1fci56heuyczr');
                script.setAttribute('data-apptype', 'csb');
                script.setAttribute('data-streamuuid', this.streamId);
                script.setAttribute('data-streamuser', this.hashedUsername);
                script.setAttribute('data-env', 'betting');
                script.setAttribute('data-oauthtoken', this.token);
                script.setAttribute('data-streamonly', 'true');
                script.setAttribute('data-videoonly', 'true');
                script.setAttribute('data-width', this.containerWidth);

                script.onerror = (error) => sendMultimediaRequestResultAnalytic(
                    this.expandedEventData,
                    'false',
                    new Error('Failed to load player script'),
                    [error?.message],
                );

                this.$refs.performScript.appendChild(script);
            },
        },
    };
</script>
